import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cn from 'classnames';
import styles from 'shop-views/Box.scss';

var _excluded = ["children", "className"],
    _excluded2 = ["children", "className"],
    _excluded3 = ["children", "className"];
var Box = _ref => {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cn(styles.box, className)
  }), children);
};
var BoxHeader = _ref2 => {
  var children = _ref2.children,
      className = _ref2.className,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement("header", _extends({}, props, {
    className: cn(styles.boxHeader, {
      [styles.interactive]: Boolean(props.onClick)
    }, className)
  }), children);
};
var BoxBody = _ref3 => {
  var children = _ref3.children,
      className = _ref3.className,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cn(styles.boxBody, className)
  }), children);
};

export { Box, BoxBody, BoxHeader };
//# sourceMappingURL=index.js.map
